import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, StoryBlockData } from '../../../../models';
import { StoryNodeView } from './StoryNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    storyNode: { insertStoryNode: ({ story }: StoryBlockData) => ReturnType };
  }
}

export const StoryNode = Node.create({
  name: 'storyNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { story: null };
  },

  parseHTML() {
    return [{ tag: BlockTypes.story }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.story, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertStoryNode:
        ({ story }: StoryBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { story } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(StoryNodeView);
  },
});
